import { i18next as L, MessageTypeRegistry as ne, ChativaElement as g, t as le, chatStore as ce } from "@chativa/core";
import { css as f, html as a, nothing as c, svg as B } from "lit";
import { property as l, customElement as b, state as $ } from "lit/decorators.js";
const pe = {
  "genui.form.processing": "Processing…",
  "genui.form.submit": "Submit",
  "genui.form.successTitle": "Success",
  "genui.form.successDefault": "Done!",
  "genui.form.errorDefault": "Something went wrong.",
  "genui.appointment.title": "Book an Appointment",
  "genui.appointment.submit": "Book Now",
  "genui.appointment.successDefault": "Appointment successfully booked.",
  "genui.appointment.codeHint": "Please save this code for your reference.",
  "genui.appointment.copy": "Copy",
  "genui.appointment.copied": "Copied!",
  "genui.rating.ariaLabel": "Star rating",
  "genui.rating.starLabel": "{{count}} star",
  "genui.rating.submit": "Submit",
  "genui.rating.thankYou": "Thank you for your feedback!",
  "genui.datePicker.label": "Select date"
}, de = {
  "genui.form.processing": "İşleniyor…",
  "genui.form.submit": "Gönder",
  "genui.form.successTitle": "Başarılı",
  "genui.form.successDefault": "Tamamlandı!",
  "genui.form.errorDefault": "Bir şeyler ters gitti.",
  "genui.appointment.title": "Randevu Al",
  "genui.appointment.submit": "Şimdi Randevu Al",
  "genui.appointment.successDefault": "Randevunuz başarıyla alındı.",
  "genui.appointment.codeHint": "Bu kodu referans olarak saklayın.",
  "genui.appointment.copy": "Kopyala",
  "genui.appointment.copied": "Kopyalandı!",
  "genui.rating.ariaLabel": "Yıldız puanı",
  "genui.rating.starLabel": "{{count}} yıldız",
  "genui.rating.submit": "Gönder",
  "genui.rating.thankYou": "Geri bildiriminiz için teşekkür ederiz!",
  "genui.datePicker.label": "Tarih seçin"
};
function te() {
  L.addResources("en", "translation", pe), L.addResources("tr", "translation", de);
}
L.isInitialized ? te() : L.on("initialized", te);
const G = /* @__PURE__ */ new Map(), m = {
  /**
   * Register a LitElement constructor under a name.
   * @param name      Must match `AIChunkUI.component` sent by the connector.
   * @param component LitElement constructor (or any HTMLElement subclass).
   * @param opts.schema  Optional schema for prop validation at render time.
   */
  register(e, t, s) {
    G.set(e, { component: t, schema: s?.schema });
  },
  /** Resolve a registered entry, or undefined if not found. */
  resolve(e) {
    return G.get(e);
  },
  has(e) {
    return G.has(e);
  },
  /** Remove a registration. */
  unregister(e) {
    G.delete(e);
  },
  /** List all registered names. */
  list() {
    return Array.from(G.keys());
  },
  /** Reset — for use in tests only. */
  clear() {
    G.clear();
  }
}, re = f`
  .chativa-bubble {
    background: #f1f5f9;
    color: #0f172a;
    border-radius: 4px 16px 16px 16px;
    padding: 9px 13px;
    font-family: var(--chativa-font-family, inherit);
    font-size: 0.875rem;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    width: fit-content;
    max-width: 100%;
    box-sizing: border-box;
  }
`;
var he = Object.defineProperty, ue = Object.getOwnPropertyDescriptor, C = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? ue(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && he(t, s, i), i;
};
let x = class extends g {
  constructor() {
    super(...arguments), this.messageData = {}, this.sender = "bot", this.messageId = "", this.timestamp = 0, this.hideAvatar = !1, this.status = "sent", this.debug = !1, this._instances = /* @__PURE__ */ new Map(), this._listeners = /* @__PURE__ */ new Map(), this._dispatchedEvents = /* @__PURE__ */ new Set(), this._sendEvent = (e, t, s) => {
      const r = this._listeners.get(e);
      r && r.forEach(({ targetId: i, cb: o }) => {
        (i === void 0 || i === s) && o(t);
      }), this.dispatchEvent(
        new CustomEvent("genui-send-event", {
          detail: { msgId: this.messageId, eventType: e, payload: t, sourceId: s },
          bubbles: !0,
          composed: !0
        })
      );
    }, this._listenEvent = (e, t, s) => {
      this._listeners.has(e) || this._listeners.set(e, /* @__PURE__ */ new Set()), this._listeners.get(e).add({ targetId: s, cb: t });
    };
  }
  // ── Chunk rendering ───────────────────────────────────────────────────────
  _renderTextChunk(e) {
    return a`<div class="chunk-enter chativa-bubble">${e.content}</div>`;
  }
  _renderUIChunk(e) {
    const t = m.resolve(e.component);
    if (!t)
      return this.debug ? a`
        <div class="unknown-fallback chunk-enter">
          <strong>Unknown component:</strong> "${e.component}"
        </div>
      ` : a``;
    if (t.schema) {
      const r = t.schema.safeParse(e.props);
      if (!r.success)
        return console.error(`[GenUI] Prop validation failed for "${e.component}":`, r.error), a`
          <div class="error-fallback chunk-enter">
            <strong>Invalid props</strong> for "${e.component}" — see console for details.
          </div>
        `;
    }
    let s = this._instances.get(e.id);
    if (!s) {
      s = new t.component(), this._instances.set(e.id, s);
      const r = s;
      r.sendEvent = (i, o) => this._sendEvent(i, o, e.id), r.listenEvent = (i, o) => this._listenEvent(i, o, e.id), r.tFn = (i, o) => le(i, { defaultValue: o ?? i }), r.onLangChange = (i) => (L.on("languageChanged", i), () => L.off("languageChanged", i));
    }
    return Object.assign(s, e.props), a`<div class="chunk-enter">${s}</div>`;
  }
  // ── Dispatch pending event chunks ─────────────────────────────────────────
  _dispatchEventChunks(e) {
    for (const t of e) {
      if (this._dispatchedEvents.has(t.id)) continue;
      this._dispatchedEvents.add(t.id);
      const s = this._listeners.get(t.name);
      s && s.forEach(({ targetId: r, cb: i }) => {
        (t.for === void 0 || r === void 0 || r === t.for) && i(t.payload);
      });
    }
  }
  // ── Render ────────────────────────────────────────────────────────────────
  get _time() {
    return this.timestamp ? new Date(this.timestamp).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit"
    }) : "";
  }
  _renderAvatar(e) {
    return a`
      <div class="avatar ${this.hideAvatar ? "hidden" : ""}">
        ${e ? a`<img src=${e} alt="bot avatar" />` : a`
              <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <rect x="5" y="8" width="14" height="12" rx="2.5" />
                <circle cx="9.5" cy="13" r="1.5" fill="white" />
                <circle cx="14.5" cy="13" r="1.5" fill="white" />
                <path
                  d="M9.5 17c.5.5 1.4.8 2.5.8s2-.3 2.5-.8"
                  stroke="white"
                  stroke-width="1.2"
                  stroke-linecap="round"
                  fill="none"
                />
              </svg>
            `}
      </div>
    `;
  }
  render() {
    const e = this.messageData, t = e?.chunks ?? [], s = e?.streamingComplete ?? !1, r = t.filter((p) => p.type === "event");
    this._dispatchEventChunks(r);
    const i = t.filter(
      (p) => p.type !== "event"
    ), o = i[i.length - 1], n = !s && (!o || o.type !== "ui"), d = ce.getState().theme.avatar, h = d?.showBot !== !1;
    return a`
      <div class="message" role="article">
        ${h ? this._renderAvatar(d?.bot) : c}
        <div class="content">
          <div class="genui-wrapper">
            ${i.map((p) => p.type === "text" ? this._renderTextChunk(p) : p.type === "ui" ? this._renderUIChunk(p) : c)}
            ${n ? a`
              <div class="typing-dots">
                <span></span><span></span><span></span>
              </div>
            ` : c}
          </div>
          ${this._time ? a`<span class="time" aria-hidden="true">${this._time}</span>` : c}
        </div>
      </div>
    `;
  }
};
x.styles = [re, f`
    :host {
      display: block;
      width: 100%;
    }

    /* Same row layout as the built-in message types so GenUI content
       lines up with regular bot bubbles (avatar gutter + 82% cap). */
    .message {
      display: flex;
      align-items: flex-end;
      gap: 8px;
      max-width: 82%;
      margin-right: auto;
      margin-bottom: 2px;
    }

    .avatar {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: #ede9fe;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      overflow: hidden;
    }

    .avatar.hidden { visibility: hidden; }

    .avatar svg {
      width: 16px;
      height: 16px;
      color: #7c3aed;
    }

    .avatar img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: 3px;
      flex: 1;
      min-width: 0;
      /* Single inheritance point for the whole GenUI subtree — built-in and
         custom components pick this up unless they override it themselves. */
      font-family: var(--chativa-font-family, inherit);
    }

    /* Text chunks render as regular bot bubbles (shared chativa-bubble
       look from ../styles/bubble) so mixed text + component streams read
       like one conversation. */

    .genui-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 4px 0;
      min-width: 0;
    }

    .chunk-enter {
      animation: chunkFadeIn 0.35s ease-out both;
      max-width: 100%;
      min-width: 0;
    }

    /* Custom components can declare any width — never let them push
       past the message column (widget viewport). */
    .chunk-enter > * {
      max-width: 100%;
      box-sizing: border-box;
    }

    .time {
      font-size: 0.6875rem;
      color: #94a3b8;
      padding: 0 2px;
    }

    @keyframes chunkFadeIn {
      from { opacity: 0; transform: translateY(8px); }
      to   { opacity: 1; transform: translateY(0); }
    }

    .typing-dots {
      display: flex;
      gap: 4px;
      padding: 6px 2px;
      align-items: center;
    }

    .typing-dots span {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      background: #94a3b8;
      animation: dotBounce 1.2s infinite ease-in-out;
    }

    .typing-dots span:nth-child(2) { animation-delay: 0.15s; }
    .typing-dots span:nth-child(3) { animation-delay: 0.30s; }

    @keyframes dotBounce {
      0%, 80%, 100% { transform: translateY(0); opacity: 0.5; }
      40%            { transform: translateY(-5px); opacity: 1; }
    }

    .error-fallback {
      padding: 10px 14px;
      border: 1px dashed #f87171;
      border-radius: 8px;
      color: #ef4444;
      font-size: 0.8125rem;
      font-family: inherit;
    }

    .unknown-fallback {
      padding: 10px 14px;
      border: 1px dashed #fb923c;
      border-radius: 8px;
      color: #ea580c;
      font-size: 0.8125rem;
      font-family: inherit;
    }
  `];
C([
  l({ type: Object })
], x.prototype, "messageData", 2);
C([
  l({ type: String })
], x.prototype, "sender", 2);
C([
  l({ type: String })
], x.prototype, "messageId", 2);
C([
  l({ type: Number })
], x.prototype, "timestamp", 2);
C([
  l({ type: Boolean })
], x.prototype, "hideAvatar", 2);
C([
  l({ type: String })
], x.prototype, "status", 2);
C([
  l({ type: Boolean })
], x.prototype, "debug", 2);
x = C([
  b("genui-message")
], x);
try {
  ne.register("genui", x);
} catch {
}
var fe = Object.defineProperty, ge = Object.getOwnPropertyDescriptor, se = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? ge(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && fe(t, s, i), i;
};
let V = class extends g {
  constructor() {
    super(...arguments), this.content = "";
  }
  render() {
    return a`<div class="chativa-bubble">${this.content}</div>`;
  }
};
V.styles = [
  re,
  f`
      :host {
        display: block;
      }
    `
];
se([
  l({ type: String })
], V.prototype, "content", 2);
V = se([
  b("genui-text-block")
], V);
var be = Object.defineProperty, me = Object.getOwnPropertyDescriptor, R = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? me(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && be(t, s, i), i;
};
let P = class extends g {
  constructor() {
    super(...arguments), this.title = "", this.description = "", this.image = "", this.actions = [];
  }
  _onAction(e) {
    this.dispatchEvent(
      new CustomEvent("chat-action", {
        detail: e,
        bubbles: !0,
        composed: !0
      })
    );
  }
  render() {
    return a`
      <div class="card">
        ${this.image ? a`<img class="card-image" src=${this.image} alt=${this.title} />` : c}
        <div class="card-body">
          ${this.title ? a`<h3 class="card-title">${this.title}</h3>` : c}
          ${this.description ? a`<p class="card-description">${this.description}</p>` : c}
          ${this.actions.length > 0 ? a`
                <div class="card-actions">
                  ${this.actions.map(
      (e) => a`
                      <button
                        class="action-btn"
                        type="button"
                        @click=${() => this._onAction(e.value)}
                      >${e.label}</button>
                    `
    )}
                </div>
              ` : c}
        </div>
      </div>
    `;
  }
};
P.styles = f`
    :host {
      display: block;
    }

    .card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: box-shadow 0.2s ease;
      max-width: 320px;
      font-family: inherit;
    }

    .card:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
    }

    .card-image {
      width: 100%;
      height: 160px;
      object-fit: cover;
      display: block;
    }

    .card-body {
      padding: 14px 16px;
    }

    .card-title {
      margin: 0 0 6px;
      font-size: 1rem;
      font-weight: 600;
      color: #0f172a;
    }

    .card-description {
      margin: 0 0 12px;
      font-size: 0.8125rem;
      color: #64748b;
      line-height: 1.5;
    }

    .card-actions {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .action-btn {
      padding: 7px 14px;
      border: 1.5px solid var(--chativa-primary-color, #4f46e5);
      border-radius: 999px;
      background: transparent;
      color: var(--chativa-primary-color, #4f46e5);
      font-size: 0.8125rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: background 0.15s, color 0.15s;
    }

    .action-btn:hover {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
    }
  `;
R([
  l({ type: String })
], P.prototype, "title", 2);
R([
  l({ type: String })
], P.prototype, "description", 2);
R([
  l({ type: String })
], P.prototype, "image", 2);
R([
  l({ type: Array })
], P.prototype, "actions", 2);
P = R([
  b("genui-card")
], P);
var xe = Object.defineProperty, ve = Object.getOwnPropertyDescriptor, I = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? ve(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && xe(t, s, i), i;
};
let v = class extends g {
  constructor() {
    super(...arguments), this.title = "", this.fields = [], this.buttonText = "", this._submitted = !1, this._processing = !1, this._successMessage = "", this._errorMessage = "";
  }
  connectedCallback() {
    super.connectedCallback(), this.listenEvent?.("form_success", (e) => {
      this._processing = !1, this._submitted = !0;
      const t = e;
      this._successMessage = t.message ?? this.t("genui.form.successDefault", { defaultValue: "Done!" });
    }), this.listenEvent?.("form_error", (e) => {
      this._processing = !1;
      const t = e;
      this._errorMessage = t.message ?? this.t("genui.form.errorDefault", { defaultValue: "Something went wrong." });
    });
  }
  _onSubmit(e) {
    if (e.preventDefault(), this._processing || this._submitted) return;
    const t = e.target, s = {};
    new FormData(t).forEach((r, i) => {
      s[i] = String(r);
    }), this._processing = !0, this._errorMessage = "", this.sendEvent?.("form_submit", s);
  }
  render() {
    const e = this.buttonText || this.t("genui.form.submit", { defaultValue: "Submit" });
    return this._submitted ? a`
        <div class="success-card">
          <div class="success-icon">✅</div>
          <h3 class="success-title">${this.t("genui.form.successTitle", { defaultValue: "Success" })}</h3>
          <p class="success-message">${this._successMessage}</p>
        </div>
      ` : a`
      <div class="form-card">
        ${this.title ? a`<h3 class="form-title">${this.title}</h3>` : c}
        <form @submit=${this._onSubmit}>
          ${this.fields.map((t) => a`
            <div class="field">
              <label for="genui-field-${t.name}">${t.label}</label>
              <input
                id="genui-field-${t.name}"
                name=${t.name}
                type=${t.type}
                placeholder=${t.placeholder ?? ""}
                .value=${t.value ?? ""}
                ?required=${t.required !== !1}
                ?disabled=${t.disabled === !0 || this._processing}
              />
            </div>
          `)}
          <button
            class="submit-btn"
            type="submit"
            ?disabled=${this._processing}
          >
            ${this._processing ? this.t("genui.form.processing", { defaultValue: "Processing…" }) : e}
          </button>
          ${this._errorMessage ? a`<div class="error-msg">${this._errorMessage}</div>` : c}
        </form>
      </div>
    `;
  }
};
v.styles = f`
    :host {
      display: block;
    }

    .form-card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 20px;
      max-width: 360px;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      font-family: inherit;
    }

    .form-title {
      margin: 0 0 16px;
      font-size: 1rem;
      font-weight: 600;
      color: #0f172a;
    }

    .field {
      margin-bottom: 14px;
    }

    label {
      display: block;
      font-size: 0.8125rem;
      font-weight: 500;
      color: #475569;
      margin-bottom: 4px;
    }

    input {
      width: 100%;
      padding: 8px 12px;
      border: 1.5px solid #e2e8f0;
      border-radius: 8px;
      font-size: 0.875rem;
      box-sizing: border-box;
      background: #f8fafc;
      color: #0f172a;
      font-family: inherit;
      transition: border-color 0.15s;
      outline: none;
    }

    input:focus {
      border-color: var(--chativa-primary-color, #4f46e5);
      background: #ffffff;
    }

    input:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    .submit-btn {
      width: 100%;
      padding: 10px;
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
      border: none;
      border-radius: 8px;
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: opacity 0.15s;
      margin-top: 4px;
    }

    .submit-btn:hover { opacity: 0.9; }
    .submit-btn:disabled { opacity: 0.5; cursor: not-allowed; }

    /* Success state */
    .success-card {
      border: 1px solid #bbf7d0;
      border-radius: 12px;
      padding: 20px;
      max-width: 360px;
      background: #f0fdf4;
      text-align: center;
      font-family: inherit;
    }

    .success-icon {
      font-size: 2rem;
      margin-bottom: 8px;
    }

    .success-title {
      margin: 0 0 6px;
      font-size: 1rem;
      font-weight: 600;
      color: #15803d;
    }

    .success-message {
      font-size: 0.8125rem;
      color: #166534;
    }

    .error-msg {
      margin-top: 10px;
      padding: 8px 12px;
      background: #fef2f2;
      border: 1px solid #fecaca;
      border-radius: 6px;
      font-size: 0.8125rem;
      color: #dc2626;
    }
  `;
I([
  l({ type: String })
], v.prototype, "title", 2);
I([
  l({ type: Array })
], v.prototype, "fields", 2);
I([
  l({ type: String })
], v.prototype, "buttonText", 2);
I([
  $()
], v.prototype, "_submitted", 2);
I([
  $()
], v.prototype, "_processing", 2);
I([
  $()
], v.prototype, "_successMessage", 2);
I([
  $()
], v.prototype, "_errorMessage", 2);
v = I([
  b("genui-form")
], v);
var ye = Object.defineProperty, _e = Object.getOwnPropertyDescriptor, Y = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? _e(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && ye(t, s, i), i;
};
let S = class extends g {
  constructor() {
    super(...arguments), this.variant = "info", this.title = "", this.message = "", this.icon = "";
  }
  _defaultIcon() {
    return {
      info: "ℹ️",
      success: "✅",
      warning: "⚠️",
      error: "❌"
    }[this.variant] ?? "ℹ️";
  }
  render() {
    const e = this.icon || this._defaultIcon();
    return a`
      <div class="alert alert--${this.variant}" role="alert">
        <span class="icon" aria-hidden="true">${e}</span>
        <div class="body">
          ${this.title ? a`<p class="title">${this.title}</p>` : c}
          ${this.message ? a`<p class="message">${this.message}</p>` : c}
        </div>
      </div>
    `;
  }
};
S.styles = f`
    :host { display: block; }

    .alert {
      display: flex;
      gap: 12px;
      align-items: flex-start;
      padding: 14px 16px;
      border-radius: 10px;
      border-left: 4px solid;
      font-family: inherit;
      max-width: 420px;
    }

    .icon {
      font-size: 1.125rem;
      line-height: 1;
      flex-shrink: 0;
      margin-top: 1px;
    }

    .body { flex: 1; min-width: 0; }

    .title {
      margin: 0 0 2px;
      font-size: 0.875rem;
      font-weight: 600;
    }

    .message {
      margin: 0;
      font-size: 0.8125rem;
      line-height: 1.5;
    }

    /* Variants */
    .alert--info    { background: #eff6ff; border-color: #3b82f6; color: #1e40af; }
    .alert--success { background: #f0fdf4; border-color: #22c55e; color: #15803d; }
    .alert--warning { background: #fffbeb; border-color: #f59e0b; color: #92400e; }
    .alert--error   { background: #fef2f2; border-color: #ef4444; color: #991b1b; }
  `;
Y([
  l({ type: String })
], S.prototype, "variant", 2);
Y([
  l({ type: String })
], S.prototype, "title", 2);
Y([
  l({ type: String })
], S.prototype, "message", 2);
Y([
  l({ type: String })
], S.prototype, "icon", 2);
S = Y([
  b("genui-alert")
], S);
var we = Object.defineProperty, $e = Object.getOwnPropertyDescriptor, q = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? $e(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && we(t, s, i), i;
};
let j = class extends g {
  constructor() {
    super(...arguments), this.label = "", this.items = [], this._selectedValue = "";
  }
  _onSelect(e) {
    this._selectedValue || (this._selectedValue = e.value, this.dispatchEvent(
      new CustomEvent("chat-action", {
        detail: e.value,
        bubbles: !0,
        composed: !0
      })
    ));
  }
  render() {
    const e = !!this._selectedValue;
    return a`
      ${this.label ? a`<p class="label">${this.label}</p>` : c}
      <div class="buttons" role="list">
        ${this.items.map((t) => a`
          <button
            class="reply-btn ${this._selectedValue === t.value ? "reply-btn--selected" : ""}"
            type="button"
            role="listitem"
            ?disabled=${e}
            @click=${() => this._onSelect(t)}
          >${t.label}</button>
        `)}
      </div>
    `;
  }
};
j.styles = f`
    :host { display: block; }

    .label {
      font-size: 0.8125rem;
      color: #64748b;
      margin: 0 0 8px;
      font-family: inherit;
    }

    .buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .reply-btn {
      padding: 7px 16px;
      border: 1.5px solid var(--chativa-primary-color, #4f46e5);
      border-radius: 999px;
      background: transparent;
      color: var(--chativa-primary-color, #4f46e5);
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: background 0.15s, color 0.15s, opacity 0.15s;
      white-space: nowrap;
    }

    .reply-btn:hover:not(:disabled) {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
    }

    .reply-btn:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    .reply-btn--selected {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
      opacity: 1 !important;
    }
  `;
q([
  l({ type: String })
], j.prototype, "label", 2);
q([
  l({ type: Array })
], j.prototype, "items", 2);
q([
  $()
], j.prototype, "_selectedValue", 2);
j = q([
  b("genui-quick-replies")
], j);
var ke = Object.defineProperty, Pe = Object.getOwnPropertyDescriptor, H = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? Pe(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && ke(t, s, i), i;
};
let E = class extends g {
  constructor() {
    super(...arguments), this.title = "", this.ordered = !1, this.items = [];
  }
  _renderItems() {
    return this.items.map((e, t) => a`
      <li>
        ${this.ordered ? a`<span class="item-number">${t + 1}.</span>` : e.icon ? a`<span class="item-icon" aria-hidden="true">${e.icon}</span>` : a`<span class="item-icon" aria-hidden="true">•</span>`}
        <div class="item-body">
          <div class="item-text">${e.text}</div>
          ${e.secondary ? a`<div class="item-secondary">${e.secondary}</div>` : c}
        </div>
      </li>
    `);
  }
  render() {
    return a`
      <div class="list-container">
        ${this.title ? a`<h3 class="list-title">${this.title}</h3>` : c}
        ${this.ordered ? a`<ol>${this._renderItems()}</ol>` : a`<ul>${this._renderItems()}</ul>`}
      </div>
    `;
  }
};
E.styles = f`
    :host { display: block; }

    .list-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px;
      max-width: 400px;
      font-family: inherit;
    }

    .list-title {
      margin: 0 0 12px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    ol, ul {
      margin: 0;
      padding: 0;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    li {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      padding: 8px 10px;
      background: #f8fafc;
      border-radius: 8px;
    }

    .item-icon {
      font-size: 1rem;
      line-height: 1.4;
      flex-shrink: 0;
      min-width: 20px;
      text-align: center;
    }

    .item-number {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--chativa-primary-color, #4f46e5);
      flex-shrink: 0;
      min-width: 20px;
      line-height: 1.4;
    }

    .item-body { flex: 1; min-width: 0; }

    .item-text {
      font-size: 0.875rem;
      color: #0f172a;
      line-height: 1.4;
    }

    .item-secondary {
      font-size: 0.75rem;
      color: #94a3b8;
      margin-top: 2px;
    }
  `;
H([
  l({ type: String })
], E.prototype, "title", 2);
H([
  l({ type: Boolean })
], E.prototype, "ordered", 2);
H([
  l({ type: Array })
], E.prototype, "items", 2);
E = H([
  b("genui-list")
], E);
var Se = Object.defineProperty, ze = Object.getOwnPropertyDescriptor, J = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? ze(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && Se(t, s, i), i;
};
let A = class extends g {
  constructor() {
    super(...arguments), this.title = "", this.columns = [], this.rows = [];
  }
  render() {
    const e = this.columns.length === 0 && this.rows.every((t) => t.length === 2);
    return a`
      <div class="table-container">
        ${this.title ? a`<h3 class="table-title">${this.title}</h3>` : c}
        <div class="scroll-wrapper">
        <table>
          ${this.columns.length > 0 ? a`
            <thead>
              <tr>
                ${this.columns.map((t) => a`<th scope="col">${t}</th>`)}
              </tr>
            </thead>
          ` : c}
          <tbody>
            ${this.rows.map((t) => a`
              <tr>
                ${t.map((s, r) => a`
                  <td class=${e && r === 0 ? "kv-key" : ""}>${s}</td>
                `)}
              </tr>
            `)}
          </tbody>
        </table>
        </div>
      </div>
    `;
  }
};
A.styles = f`
    :host { display: block; }

    .table-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      overflow: hidden;
      max-width: 480px;
      font-family: inherit;
    }

    .scroll-wrapper {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .table-title {
      padding: 14px 16px 0;
      margin: 0 0 10px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    table {
      width: max-content;
      min-width: 100%;
      border-collapse: collapse;
      font-size: 0.8125rem;
    }

    thead th {
      background: #f1f5f9;
      padding: 9px 14px;
      text-align: left;
      font-weight: 600;
      color: #475569;
      border-bottom: 1px solid #e2e8f0;
    }

    tbody tr:nth-child(even) td {
      background: #f8fafc;
    }

    tbody td {
      padding: 9px 14px;
      color: #0f172a;
      border-bottom: 1px solid #f1f5f9;
      vertical-align: top;
    }

    tbody tr:last-child td { border-bottom: none; }

    /* Key-value mode (2 columns, no header) */
    .kv-key {
      font-weight: 500;
      color: #64748b;
      width: 40%;
    }
  `;
J([
  l({ type: String })
], A.prototype, "title", 2);
J([
  l({ type: Array })
], A.prototype, "columns", 2);
J([
  l({ type: Array })
], A.prototype, "rows", 2);
A = J([
  b("genui-table")
], A);
var Oe = Object.defineProperty, Ce = Object.getOwnPropertyDescriptor, D = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? Ce(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && Oe(t, s, i), i;
};
let y = class extends g {
  constructor() {
    super(...arguments), this.title = "", this.maxStars = 5, this.readonly = !1, this.value = 0, this._selected = 0, this._hovered = 0, this._submitted = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.value && (this._selected = this.value);
  }
  _onStarClick(e) {
    this.readonly || this._submitted || (this._selected = e);
  }
  _onSubmit() {
    !this._selected || this._submitted || (this._submitted = !0, this.sendEvent?.("rating_submit", { rating: this._selected }));
  }
  render() {
    const e = Array.from({ length: this.maxStars }, (r, i) => i + 1), t = this._hovered || this._selected, s = this.readonly || this._submitted;
    return a`
      <div class="rating-card">
        ${this.title ? a`<h3 class="rating-title">${this.title}</h3>` : c}
        <div class="stars" role="group" aria-label=${this.t("genui.rating.ariaLabel", { defaultValue: "Star rating" })}>
          ${e.map((r) => a`
            <button
              class="star ${r <= t ? "star--active" : ""} ${r === this._hovered && !s ? "star--hovered" : ""}"
              type="button"
              aria-label=${this.t("genui.rating.starLabel", { count: r, defaultValue: "{{count}} star" })}
              ?disabled=${s}
              @click=${() => this._onStarClick(r)}
              @mouseenter=${() => {
      s || (this._hovered = r);
    }}
              @mouseleave=${() => {
      this._hovered = 0;
    }}
            >⭐</button>
          `)}
        </div>
        ${this._submitted ? a`<p class="thank-you">${this.t("genui.rating.thankYou", { defaultValue: "Thank you for your feedback!" })}</p>` : s ? c : a`
                <button
                  class="submit-btn"
                  type="button"
                  ?disabled=${!this._selected}
                  @click=${this._onSubmit}
                >${this.t("genui.rating.submit", { defaultValue: "Submit" })}</button>
              `}
      </div>
    `;
  }
};
y.styles = f`
    :host { display: block; }

    .rating-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 18px 20px;
      max-width: 320px;
      text-align: center;
      font-family: inherit;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    }

    .rating-title {
      margin: 0 0 14px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    .stars {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 4px;
      /* Breathing room so the hover scale-up never clips or spills
         past the card edge. */
      padding: 4px 6px;
      margin-bottom: 10px;
    }

    .star {
      font-size: 1.75rem;
      cursor: pointer;
      transition: transform 0.1s ease, opacity 0.1s;
      line-height: 1.2;
      border: none;
      background: none;
      padding: 2px 3px;
      opacity: 0.3;
      user-select: none;
    }

    .star:focus-visible {
      outline: 2px solid var(--chativa-primary-color, #4f46e5);
      border-radius: 4px;
    }

    .star--active { opacity: 1; }
    .star--hovered { transform: scale(1.2); opacity: 1; }

    .star[disabled] { cursor: default; }

    .submit-btn {
      padding: 8px 24px;
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
      border: none;
      border-radius: 8px;
      font-size: 0.875rem;
      font-weight: 500;
      cursor: pointer;
      font-family: inherit;
      transition: opacity 0.15s;
    }

    .submit-btn:hover { opacity: 0.88; }
    .submit-btn:disabled { opacity: 0.4; cursor: not-allowed; }

    .thank-you {
      font-size: 0.875rem;
      color: #16a34a;
      font-weight: 500;
    }
  `;
D([
  l({ type: String })
], y.prototype, "title", 2);
D([
  l({ type: Number })
], y.prototype, "maxStars", 2);
D([
  l({ type: Boolean })
], y.prototype, "readonly", 2);
D([
  l({ type: Number })
], y.prototype, "value", 2);
D([
  $()
], y.prototype, "_selected", 2);
D([
  $()
], y.prototype, "_hovered", 2);
D([
  $()
], y.prototype, "_submitted", 2);
y = D([
  b("genui-rating")
], y);
var Ie = Object.defineProperty, De = Object.getOwnPropertyDescriptor, K = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? De(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && Ie(t, s, i), i;
};
let z = class extends g {
  constructor() {
    super(...arguments), this.label = "", this.value = 0, this.caption = "", this.variant = "default";
  }
  render() {
    const e = Math.min(100, Math.max(0, this.value));
    return a`
      <div class="progress-container">
        ${this.label || e !== void 0 ? a`
          <div class="progress-header">
            ${this.label ? a`<span class="progress-label">${this.label}</span>` : c}
            <span class="progress-value">${e}%</span>
          </div>
        ` : c}
        <div class="track" role="progressbar" aria-valuenow=${e} aria-valuemin="0" aria-valuemax="100">
          <div class="bar bar--${this.variant}" style="width: ${e}%"></div>
        </div>
        ${this.caption ? a`<p class="progress-caption">${this.caption}</p>` : c}
      </div>
    `;
  }
};
z.styles = f`
    :host { display: block; }

    .progress-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 10px;
      padding: 14px 16px;
      max-width: 400px;
      font-family: inherit;
    }

    .progress-header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: 8px;
    }

    .progress-label {
      font-size: 0.875rem;
      font-weight: 500;
      color: #0f172a;
    }

    .progress-value {
      font-size: 0.8125rem;
      font-weight: 600;
      color: #64748b;
    }

    .track {
      width: 100%;
      height: 8px;
      background: #e2e8f0;
      border-radius: 999px;
      overflow: hidden;
    }

    .bar {
      height: 100%;
      border-radius: 999px;
      transition: width 0.4s ease;
    }

    .bar--default { background: var(--chativa-primary-color, #4f46e5); }
    .bar--success  { background: #22c55e; }
    .bar--warning  { background: #f59e0b; }
    .bar--error    { background: #ef4444; }

    .progress-caption {
      margin-top: 6px;
      font-size: 0.75rem;
      color: #94a3b8;
    }
  `;
K([
  l({ type: String })
], z.prototype, "label", 2);
K([
  l({ type: Number })
], z.prototype, "value", 2);
K([
  l({ type: String })
], z.prototype, "caption", 2);
K([
  l({ type: String })
], z.prototype, "variant", 2);
z = K([
  b("genui-progress")
], z);
var je = Object.defineProperty, Ee = Object.getOwnPropertyDescriptor, T = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? Ee(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && je(t, s, i), i;
};
let w = class extends g {
  constructor() {
    super(...arguments), this.disabled = !1;
  }
  _onChange(e) {
    const t = e.target.value;
    this.value = t, this.sendEvent?.("date_select", { date: t });
  }
  render() {
    const e = this.label ?? this.t("genui.datePicker.label");
    return a`
      <div class="date-card">
        <label for="genui-date-input">${e}</label>
        <input
          id="genui-date-input"
          type="date"
          .value=${this.value ?? ""}
          ?disabled=${this.disabled}
          min=${this.min ?? c}
          max=${this.max ?? c}
          @change=${this._onChange}
        />
      </div>
    `;
  }
};
w.styles = f`
    :host {
      display: block;
    }

    .date-card {
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px 20px;
      max-width: 320px;
      background: #ffffff;
      font-family: inherit;
    }

    label {
      display: block;
      font-size: 0.8125rem;
      font-weight: 500;
      color: #475569;
      margin-bottom: 6px;
    }

    input[type="date"] {
      width: 100%;
      padding: 8px 12px;
      border: 1.5px solid #e2e8f0;
      border-radius: 8px;
      font-size: 0.875rem;
      box-sizing: border-box;
      background: #f8fafc;
      color: #0f172a;
      font-family: inherit;
      transition: border-color 0.15s;
      outline: none;
    }

    input[type="date"]:focus {
      border-color: var(--chativa-primary-color, #4f46e5);
      background: #ffffff;
    }

    input[type="date"]:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  `;
T([
  l({ type: String })
], w.prototype, "label", 2);
T([
  l({ type: String })
], w.prototype, "min", 2);
T([
  l({ type: String })
], w.prototype, "max", 2);
T([
  l({ type: String })
], w.prototype, "value", 2);
T([
  l({ type: Boolean })
], w.prototype, "disabled", 2);
w = T([
  b("genui-date-picker")
], w);
var Ae = Object.defineProperty, Me = Object.getOwnPropertyDescriptor, N = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? Me(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && Ae(t, s, i), i;
};
const ie = ["#4f46e5", "#7c3aed", "#06b6d4", "#10b981", "#f59e0b", "#ef4444"];
let O = class extends g {
  constructor() {
    super(...arguments), this.type = "bar", this.title = "";
  }
  _color(e, t) {
    return t ?? ie[e % ie.length];
  }
  // ── Bar chart ──────────────────────────────────────────────────────────────
  _renderBar() {
    const e = this.datasets ?? [], t = this.labels ?? [], s = e.flatMap((o) => o.data), r = Math.max(...s, 1), i = Math.max(...e.map((o) => o.data.length), t.length, 1);
    return a`
      <div class="bar-chart" role="img" aria-label=${this.title ?? "Bar chart"}>
        ${Array.from({ length: i }, (o, n) => a`
          <div class="bar-group">
            <div class="bars">
              ${e.map((d, h) => {
      const p = d.data[n] ?? 0, _ = Math.max(Math.round(p / r * 100), p > 0 ? 2 : 0);
      return a`
                  <div
                    class="bar"
                    style="height:${_}%;background:${this._color(h, d.color)};"
                    title="${d.label ? d.label + ": " : ""}${p}"
                  ></div>
                `;
    })}
            </div>
            ${t[n] ? a`<span class="bar-label">${t[n]}</span>` : c}
          </div>
        `)}
      </div>
      ${this._renderLegend()}
    `;
  }
  // ── Line chart ─────────────────────────────────────────────────────────────
  _renderLine() {
    const e = this.datasets ?? [];
    if (e.length === 0) return c;
    const t = 380, s = 150, r = 28, i = 16, o = e.flatMap((u) => u.data), n = Math.min(...o), d = Math.max(...o, n + 1), h = Math.max(...e.map((u) => u.data.length), 2), p = t - r * 2, _ = s - i * 2, k = (u) => r + u / (h - 1) * p, F = (u) => i + (d - u) / (d - n) * _;
    return a`
      <svg viewBox="0 0 ${t} ${s}" role="img" aria-label=${this.title ?? "Line chart"}>
        ${e.map((u, X) => {
      const ee = this._color(X, u.color), ae = u.data.map((Q, Z) => `${k(Z)},${F(Q)}`).join(" ");
      return B`
            <polyline
              points="${ae}"
              fill="none"
              stroke="${ee}"
              stroke-width="2"
              stroke-linejoin="round"
              stroke-linecap="round"
            />
            ${u.data.map((Q, Z) => B`
              <circle cx="${k(Z)}" cy="${F(Q)}" r="3.5" fill="${ee}" />
            `)}
          `;
    })}
        ${(this.labels ?? []).map((u, X) => B`
          <text
            x="${k(X)}"
            y="${s - 2}"
            text-anchor="middle"
            font-size="9"
            fill="#94a3b8"
          >${u}</text>
        `)}
      </svg>
      ${this._renderLegend()}
    `;
  }
  // ── Pie chart ──────────────────────────────────────────────────────────────
  _renderPie() {
    const e = this.datasets ?? [];
    if (e.length === 0) return c;
    const t = e.map((h) => h.data[0] ?? 0), s = t.reduce((h, p) => h + p, 0) || 1, r = 50, i = 65, o = 65, n = 2 * Math.PI * r;
    let d = 0;
    return a`
      <svg viewBox="0 0 200 130" role="img" aria-label=${this.title ?? "Pie chart"}>
        ${e.map((h, p) => {
      const _ = t[p] / s, k = `${_ * n} ${n}`, F = d * 360 - 90;
      d += _;
      const u = this._color(p, h.color);
      return B`
            <circle
              cx="${i}"
              cy="${o}"
              r="${r}"
              fill="none"
              stroke="${u}"
              stroke-width="22"
              stroke-dasharray="${k}"
              transform="rotate(${F} ${i} ${o})"
            />
          `;
    })}
        ${e.map((h, p) => {
      const _ = this._color(p, h.color), k = 16 + p * 18;
      return B`
            <circle cx="142" cy="${k}" r="5" fill="${_}" />
            <text x="152" y="${k + 4}" font-size="10" fill="#475569">${h.label ?? ""}</text>
          `;
    })}
      </svg>
    `;
  }
  // ── Legend ─────────────────────────────────────────────────────────────────
  _renderLegend() {
    const e = this.datasets ?? [];
    return e.every((t) => !t.label) ? c : a`
      <div class="legend">
        ${e.map((t, s) => a`
          <span class="legend-item">
            <span class="legend-dot" style="background:${this._color(s, t.color)};"></span>
            ${t.label}
          </span>
        `)}
      </div>
    `;
  }
  // ── Render ─────────────────────────────────────────────────────────────────
  render() {
    return a`
      <div class="chart-container">
        ${this.title ? a`<h3 class="chart-title">${this.title}</h3>` : c}
        ${this.type === "line" ? this._renderLine() : this.type === "pie" ? this._renderPie() : this._renderBar()}
      </div>
    `;
  }
};
O.styles = f`
    :host {
      display: block;
    }

    .chart-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px;
      max-width: 420px;
      font-family: inherit;
    }

    .chart-title {
      margin: 0 0 14px;
      font-size: 0.9375rem;
      font-weight: 600;
      color: #0f172a;
    }

    /* Bar chart */
    .bar-chart {
      display: flex;
      align-items: flex-end;
      gap: 6px;
      height: 160px;
    }

    .bar-group {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      height: 100%;
      justify-content: flex-end;
      min-width: 0;
    }

    .bars {
      display: flex;
      align-items: flex-end;
      gap: 2px;
      width: 100%;
      height: calc(100% - 18px);
    }

    .bar {
      flex: 1;
      border-radius: 3px 3px 0 0;
      min-height: 2px;
      transition: opacity 0.15s;
    }

    .bar:hover {
      opacity: 0.8;
    }

    .bar-label {
      font-size: 0.625rem;
      color: #64748b;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      flex-shrink: 0;
    }

    /* Legend */
    .legend {
      display: flex;
      flex-wrap: wrap;
      gap: 6px 14px;
      margin-top: 12px;
    }

    .legend-item {
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 0.75rem;
      color: #475569;
    }

    .legend-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      flex-shrink: 0;
    }

    /* SVG charts */
    svg {
      width: 100%;
      display: block;
      overflow: visible;
    }
  `;
N([
  l({ type: String })
], O.prototype, "type", 2);
N([
  l({ type: String })
], O.prototype, "title", 2);
N([
  l({ type: Array })
], O.prototype, "labels", 2);
N([
  l({ type: Array })
], O.prototype, "datasets", 2);
O = N([
  b("genui-chart")
], O);
var Ge = Object.defineProperty, Le = Object.getOwnPropertyDescriptor, oe = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? Le(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && Ge(t, s, i), i;
};
let U = class extends g {
  _renderIcon(e) {
    return e === "done" ? a`
        <div class="step-icon step-icon--done">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2 6l3 3 5-5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      ` : e === "active" ? a`
        <div class="step-icon step-icon--active">
          <div style="width:8px;height:8px;background:white;border-radius:50%;"></div>
        </div>
      ` : a`<div class="step-icon step-icon--pending"></div>`;
  }
  render() {
    const e = this.steps ?? [];
    return e.length === 0 ? c : a`
      <div class="steps-container">
        ${e.map((t) => a`
          <div class="step">
            <div class="step-left ${t.status}">
              ${this._renderIcon(t.status)}
            </div>
            <div class="step-content">
              <div class="step-label ${t.status === "pending" ? "step-label--pending" : ""}">
                ${t.label}
              </div>
              ${t.description ? a`<div class="step-description">${t.description}</div>` : c}
            </div>
          </div>
        `)}
      </div>
    `;
  }
};
U.styles = f`
    :host {
      display: block;
    }

    .steps-container {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 16px 20px;
      max-width: 380px;
      font-family: inherit;
    }

    .step {
      display: flex;
      gap: 12px;
      position: relative;
    }

    /* Vertical connector line between steps */
    .step:not(:last-child) .step-left::after {
      content: "";
      position: absolute;
      left: 11px;
      top: 28px;
      bottom: -6px;
      width: 2px;
      background: #e2e8f0;
    }

    .step:not(:last-child) .step-left.done::after {
      background: var(--chativa-primary-color, #4f46e5);
    }

    .step-left {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      flex-shrink: 0;
    }

    .step-icon {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      z-index: 1;
    }

    .step-icon--done {
      background: var(--chativa-primary-color, #4f46e5);
      color: #ffffff;
    }

    .step-icon--active {
      background: var(--chativa-primary-color, #4f46e5);
      animation: step-pulse 1.4s ease-in-out infinite;
    }

    .step-icon--pending {
      background: #ffffff;
      border: 2px solid #e2e8f0;
    }

    @keyframes step-pulse {
      0%, 100% { box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.4); }
      50%       { box-shadow: 0 0 0 6px rgba(79, 70, 229, 0); }
    }

    .step-content {
      padding-bottom: 16px;
      flex: 1;
      min-width: 0;
    }

    .step:last-child .step-content {
      padding-bottom: 0;
    }

    .step-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #0f172a;
      line-height: 1.5;
    }

    .step-label--pending {
      color: #94a3b8;
      font-weight: 400;
    }

    .step-description {
      font-size: 0.8125rem;
      color: #64748b;
      margin-top: 2px;
      line-height: 1.4;
    }
  `;
oe([
  l({ type: Array })
], U.prototype, "steps", 2);
U = oe([
  b("genui-steps")
], U);
var Te = Object.defineProperty, Be = Object.getOwnPropertyDescriptor, W = (e, t, s, r) => {
  for (var i = r > 1 ? void 0 : r ? Be(t, s) : t, o = e.length - 1, n; o >= 0; o--)
    (n = e[o]) && (i = (r ? n(t, s, i) : n(i)) || i);
  return r && i && Te(t, s, i), i;
};
let M = class extends g {
  constructor() {
    super(...arguments), this._lightboxIndex = null;
  }
  _open(e) {
    this._lightboxIndex = e;
  }
  _close() {
    this._lightboxIndex = null;
  }
  _prev() {
    if (this._lightboxIndex === null) return;
    const e = this.images?.length ?? 0;
    this._lightboxIndex = (this._lightboxIndex - 1 + e) % e;
  }
  _next() {
    if (this._lightboxIndex === null) return;
    const e = this.images?.length ?? 0;
    this._lightboxIndex = (this._lightboxIndex + 1) % e;
  }
  _onKeydown(e) {
    this._lightboxIndex !== null && (e.key === "Escape" ? this._close() : e.key === "ArrowLeft" ? this._prev() : e.key === "ArrowRight" && this._next());
  }
  connectedCallback() {
    super.connectedCallback(), this._boundKeydown = this._onKeydown.bind(this), window.addEventListener("keydown", this._boundKeydown);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._boundKeydown && window.removeEventListener("keydown", this._boundKeydown);
  }
  render() {
    const e = this.images ?? [], t = this.columns ?? 2;
    return a`
      <div class="gallery" style="grid-template-columns: repeat(${t}, 1fr);">
        ${e.map((s, r) => a`
          <div class="thumb-wrap">
            <div
              class="thumb"
              @click=${() => this._open(r)}
              role="button"
              tabindex="0"
              aria-label="${s.alt ?? s.caption ?? `Image ${r + 1}`}"
              @keydown=${(i) => {
      (i.key === "Enter" || i.key === " ") && this._open(r);
    }}
            >
              <img src="${s.src}" alt="${s.alt ?? ""}" loading="lazy" />
            </div>
            ${s.caption ? a`<span class="caption">${s.caption}</span>` : c}
          </div>
        `)}
      </div>

      ${this._lightboxIndex !== null ? this._renderLightbox(e) : c}
    `;
  }
  _renderLightbox(e) {
    const t = this._lightboxIndex, s = e[t];
    return s ? a`
      <div
        class="lightbox"
        role="dialog"
        aria-modal="true"
        aria-label="Image lightbox"
        @click=${(r) => {
      r.target === r.currentTarget && this._close();
    }}
      >
        <button class="lightbox-close" aria-label="Close lightbox" @click=${this._close}>×</button>
        ${e.length > 1 ? a`
          <button class="lightbox-nav prev" aria-label="Previous image" @click=${this._prev}>‹</button>
          <button class="lightbox-nav next" aria-label="Next image" @click=${this._next}>›</button>
        ` : c}
        <img class="lightbox-img" src="${s.src}" alt="${s.alt ?? ""}" />
        ${s.caption ? a`<div class="lightbox-caption">${s.caption}</div>` : c}
      </div>
    ` : c;
  }
};
M.styles = f`
    :host {
      display: block;
    }

    .gallery {
      display: grid;
      gap: 6px;
    }

    .thumb-wrap {
      display: flex;
      flex-direction: column;
      gap: 3px;
    }

    .thumb {
      position: relative;
      aspect-ratio: 1;
      overflow: hidden;
      border-radius: 8px;
      cursor: pointer;
      background: #e2e8f0;
    }

    .thumb img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.2s;
    }

    .thumb:hover img {
      transform: scale(1.05);
    }

    .caption {
      font-size: 0.68rem;
      color: #64748b;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    /* Lightbox */
    .lightbox {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.88);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
    }

    .lightbox-img {
      max-width: 90vw;
      max-height: 85vh;
      border-radius: 8px;
      object-fit: contain;
      user-select: none;
    }

    .lightbox-close {
      position: absolute;
      top: 16px;
      right: 16px;
      background: none;
      border: none;
      color: white;
      font-size: 2rem;
      line-height: 1;
      cursor: pointer;
      padding: 4px 8px;
      border-radius: 6px;
      transition: background 0.15s;
    }

    .lightbox-close:hover {
      background: rgba(255, 255, 255, 0.15);
    }

    .lightbox-nav {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(255, 255, 255, 0.15);
      border: none;
      color: white;
      font-size: 1.25rem;
      padding: 10px 14px;
      cursor: pointer;
      border-radius: 50%;
      transition: background 0.15s;
      line-height: 1;
    }

    .lightbox-nav:hover {
      background: rgba(255, 255, 255, 0.3);
    }

    .lightbox-nav.prev {
      left: 16px;
    }

    .lightbox-nav.next {
      right: 16px;
    }

    .lightbox-caption {
      position: absolute;
      bottom: 16px;
      left: 0;
      right: 0;
      text-align: center;
      color: rgba(255, 255, 255, 0.8);
      font-size: 0.875rem;
      pointer-events: none;
    }
  `;
W([
  l({ type: Array })
], M.prototype, "images", 2);
W([
  l({ type: Number })
], M.prototype, "columns", 2);
W([
  $()
], M.prototype, "_lightboxIndex", 2);
M = W([
  b("genui-image-gallery")
], M);
async function* Ye(e) {
  if (!e.body) throw new Error("[GenUI] Response body is empty");
  const t = e.body.getReader(), s = new TextDecoder();
  let r = "";
  try {
    for (; ; ) {
      const { done: o, value: n } = await t.read();
      if (o) break;
      r += s.decode(n, { stream: !0 });
      const d = r.split(`
`);
      r = d.pop() ?? "";
      for (const h of d) {
        const p = h.trim();
        if (p)
          try {
            yield JSON.parse(p);
          } catch (_) {
            console.error("[GenUI] Failed to parse chunk:", p, _);
          }
      }
    }
    const i = r.trim();
    if (i)
      try {
        yield JSON.parse(i);
      } catch (o) {
        console.error("[GenUI] Failed to parse final chunk:", i, o);
      }
  } finally {
    t.releaseLock();
  }
}
m.register("genui-text", V);
m.register("genui-card", P);
m.register("genui-form", v);
m.register("genui-alert", S);
m.register("genui-quick-replies", j);
m.register("genui-list", E);
m.register("genui-table", A);
m.register("genui-rating", y);
m.register("genui-progress", z);
m.register("genui-date-picker", w);
m.register("genui-chart", O);
m.register("genui-steps", U);
m.register("genui-image-gallery", M);
export {
  S as GenUIAlert,
  P as GenUICard,
  O as GenUIChart,
  w as GenUIDatePicker,
  v as GenUIForm,
  M as GenUIImageGallery,
  E as GenUIList,
  x as GenUIMessage,
  z as GenUIProgress,
  j as GenUIQuickReplies,
  y as GenUIRating,
  m as GenUIRegistry,
  U as GenUISteps,
  A as GenUITable,
  V as GenUITextBlock,
  re as bubbleStyles,
  Ye as streamFromFetch
};
//# sourceMappingURL=index.js.map
